/**
 * Constants for Custom Calendar admin fields
 */

export const CUSTOM_CALENDAR_STATUS_OPTIONS = [
	{ title: 'Intake Form Needed', value: 'Intake Form Needed' },
	{ title: 'In Progress', value: 'In Progress' },
	{ title: 'Delivered', value: 'Delivered' },
	{ title: 'Waiting on Next Intake', value: 'Waiting on Next Intake' },
] as const;

export const CUSTOM_CALENDAR_MODIFICATIONS_OPTIONS = [
	{ title: 'None', value: 'None' },
	{ title: 'Social Only', value: 'Social Only' },
	{ title: 'Email Only', value: 'Email Only' },
	{ title: 'Plus Blogs', value: 'Plus Blogs' },
] as const;

export const CUSTOM_CALENDAR_DEFAULT_STATUS = 'Intake Form Needed';

export type CustomCalendarStatus = (typeof CUSTOM_CALENDAR_STATUS_OPTIONS)[number]['value'];
export type CustomCalendarModifications = (typeof CUSTOM_CALENDAR_MODIFICATIONS_OPTIONS)[number]['value'];
